export default __webpack_public_path__ + "static/media/Background_00269.86c6ca03.png";